import { translate } from '@openclassrooms/translations';
import { getLocalisationConfig } from '@openclassrooms/localisation/services';
import { getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import { usePermissions } from '@openclassrooms/data-connect-web/users';
import {
  useUserExpectedBenefits,
  useCurrentUserContext,
} from '@openclassrooms/data-connect-web/users';

import hasHireExpectedBenefits from '../../../services/hasHireExpectedBenefits';

function usePromotionType() {
  const { can } = usePermissions();
  const { userId, currentUser } = useCurrentUserContext();
  const { data: userExpectedBenefits } = useUserExpectedBenefits(
    { userId },
    {
      enabled: Boolean(userId),
    }
  );
  const canAccessJobPostings = can('ACCESS_JOB_POSTINGS');
  if (canAccessJobPostings) {
    return 'jobMarketplace';
  }

  const isHiring = userExpectedBenefits ? hasHireExpectedBenefits(userExpectedBenefits) : false;
  const isInTalentPoolCountry = getLocalisationConfig('apprenticeship.hasTalentPool');

  const isNotEnrolled = currentUser?.enrollment === 'Free';
  const hasNoOrganization = !currentUser?.organization;

  if (isInTalentPoolCountry && isHiring && isNotEnrolled && hasNoOrganization) {
    return 'talentMarketplace';
  }
  return undefined;
}
function usePromotionProps() {
  const promotionType = usePromotionType();
  const promotionProps = {
    jobMarketplace: {
      description: translate('profile_menu.job_marketplace.banner.description'),
      ctaLabel: translate('global.word.access_job_marketplace'),
      ctaProps: {
        'data-event': 'Navigation|Redirection::Internal|Callout menu drawer find apprenticeship',
        ...getButtonLinkProps(ROUTES.DASHBOARD.JOB_POSTINGS),
      },
    },
    talentMarketplace: {
      description: translate('profile_menu.talent_marketplace.banner.description'),
      ctaLabel: translate('global.word.access_talent_marketplace'),
      ctaProps: {
        'data-event': 'Navigation|Redirection::Internal|Callout menu drawer hire apprentices',
        ...getButtonLinkProps(ROUTES.TALENTS.LIST),
      },
    },
  } as const;
  if (!promotionType) {
    return undefined;
  }
  return promotionProps[promotionType];
}
export default usePromotionProps;
